import { TdHTMLAttributes } from "react";

import { TableCell } from "@/components/_atoms/table";
import { cn } from "@/lib/cn";

export function MunicipalPropertyTableCell({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <TableCell
      className={cn("h-9 px-3 py-1.5 first:pl-[var(--chrome-gutter)] last:pr-[var(--chrome-gutter)]", className)}
      {...props}
    />
  );
}
